<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>評価状況</template>
      <template v-slot:annotation>評価進捗状況の一覧です</template>
    </PageHeader>

    <v-row>
      <v-col cols="12" md="4">
        <v-select
          label="期間（年度）"
          v-model="period"
          item-text="label"
          item-value="value"
          :items="periodItems"
          dense
          return-object
        />
      </v-col>
      <v-col v-if="isDepartmentActive" cols="12" md="4">
        <v-select
          label="部署"
          v-model="department"
          item-text="label"
          item-value="value"
          :items="departmentItems"
          dense
          return-object
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          label="評価状況"
          v-model="evalStatus"
          item-text="label"
          item-value="value"
          :items="evalStatusItems"
          dense
          return-object
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <FormInputComponent
          label="氏名"
          v-model="userNameSearch"
          :length="10"
        />
      </v-col>
      <v-col cols="4">
        <Button @click="get_evaluation()" color="primary">検索</Button>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="評価情報は見つかりませんでした。新たに検索条件を設定してください。"
        >
          <template v-slot:[`item.DELETE`]>
            <Button
              color="secondary"
              @click="$refs.confirm.open()"
              :small="true"
              >削除</Button
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DialogMessage ref="dialog" />
    <Loader :loading="loading" />
  </v-container>
</template>

<script>
import config from '@/const.js';
import axios from 'axios';
import message from '@/message.js';
import {
  getSessionStorageItem,
  convertEvaluationStatus,
  makeMonthFormatStr,
  makeDateTimeStr,
  makeSystemDateStr,
} from '@/common.js';
export default {
  components: {},
  name: 'StaffGradeSetting',

  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: '評価状況',
          route: 'Evaluation',
        },
      ],
      loading: false,
      confirm: false,
      searchKey: '',

      userInfo: {},

      items: [],
      period: { value: '', label: '' },
      periodItems: [],
      department: {},
      departmentItems: [],
      evalStatus: {},
      evalStatusItems: [],
      userItems: [],
      userNameSearch: '',

      headers: [
        {
          text: '部署',
          value: 'DEPARTMENT_NAME',
        },
        {
          text: '役職',
          value: 'POSITION_NAME',
        },
        {
          text: '氏名',
          value: 'USER_NAME',
        },
        {
          text: '評価年月',
          value: 'EVAL_MONTH',
        },
        {
          text: '評価の状態',
          value: 'STATUS',
        },
        {
          text: '評価者部署',
          value: 'EVAL_DEPARTMENT_NAME',
        },
        {
          text: '評価者氏名',
          value: 'EVAL_USER_NAME',
        },
      ],
      hasPeriod: false,
      initPeriodId: '',
    };
  },

  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    if (userInfo) {
      this.userRank = userInfo.USER_RANK;
      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_M
      ) {
        // TopとMの場合
        this.isDepartmentActive = true;
      } else {
        // 上記以外
        this.isDepartmentActive = false;
      }
    }
    // 期間(年度)の設定、組織キーに紐づくユーザー情報の取得
    this.getPeriod();
    // 部署情報の設定
    this.get_department();
    // 評価状況の設定
    this.get_evalStatus();
  },

  methods: {
    async get_evaluation() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        return;
      }

      // 期間(年度)チェック
      if (!this.period.value) {
        this.$refs.dialog.open(
          'info',
          '期間(年度)が選択されていません。期間(年度)は必須選択です。'
        );
        return;
      }
      // 年度ID
      var periodId = this.period.value;
      // 部署
      if (this.isDepartmentActive) {
        var departmentKey = this.department.value;
        if (!departmentKey) {
          departmentKey = config.EMPTY_STRING;
        }
      } else {
        departmentKey = userInfo.DEPARTMENT_KEY;
      }

      // 評価状況
      var evalStatus = this.evalStatus.value;
      if (!evalStatus) {
        evalStatus = config.EMPTY_STRING;
      }
      // 氏名
      var userName = this.userNameSearch;
      if (!userName) {
        userName = config.EMPTY_STRING;
      }

      let vm = this;
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/situation/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            periodId +
            '/' +
            departmentKey +
            '/' +
            evalStatus +
            '/' +
            userName
        )
        .then((response) => {
          // スタッフデータ取得
          vm.items = response.data;
          for (var i = 0; i < vm.items.length; i++) {
            // 状態
            vm.items[i].STATUS = convertEvaluationStatus(
              vm.items[i].EVAL_STATUS
            );

            // 評価回数設定
            var evalNoComplete = 0;
            if (
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_SELF_WAIT ||
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_SELF_DURING
            ) {
              // 1:自己評価待ち、2:自己評価中の場合
              evalNoComplete = Number(vm.items[i].EVAL_NO_COMPLETE_SELF);
            } else if (
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_FIRST_WAIT ||
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_FIRST_DURING
            ) {
              // 3:一次評価待ち、4:一次評価中の場合
              evalNoComplete = Number(vm.items[i].EVAL_NO_COMPLETE_FIRST);
            } else {
              // 上記以外の場合
              evalNoComplete = Number(vm.items[i].EVAL_NO_COMPLETE_FIRST) - 1;
            }

            // 評価年月設定
            if (evalNoComplete == 0) {
              // 1回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_1,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 1) {
              // 2回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_2,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 2) {
              // 3回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_3,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 3) {
              // 4回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_4,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 4) {
              // 5回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_5,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 5) {
              // 6回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_6,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 6) {
              // 7回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_7,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 7) {
              // 8回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_8,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 8) {
              // 9回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_9,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 9) {
              // 10回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_10,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 10) {
              // 11回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_11,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            } else if (evalNoComplete == 11) {
              // 12回目
              vm.items[i].EVAL_MONTH = makeMonthFormatStr(
                response.data[i].EVAL_MONTH_12,
                config.TITLE_REPLACE_YEAR_STR,
                config.TITLE_REPLACE_MONTH_STR
              );
            }
            // 評価者設定
            var evalUserId = '';
            if (
              // 一次評価待ち、一次評価中
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_FIRST_WAIT ||
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_FIRST_DURING
            ) {
              vm.items[i].EVAL_USER_NAME = vm.items[i].FIRST_USER_NAME;
              evalUserId = vm.items[i].FIRST_USER_ID;
            } else if (
              // 二次評価待ち、二次評価中、完了
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_SECOND_WAIT ||
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_SECOND_DURING ||
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_COMPLETE
            ) {
              vm.items[i].EVAL_USER_NAME = vm.items[i].SECOND_USER_NAME;
              evalUserId = vm.items[i].SECOND_USER_ID;
              /*
            } else if (
              // 自己評価待ち、自己評価中
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_SELF_WAIT ||
              vm.items[i].EVAL_STATUS == config.EVAL_STATUS_SELF_DURING
            ) {
              if (vm.items[i].FIRST_USER_NAME == config.GOAL_EMPTY_STRING) {
                // 一次評価者が入力されていない場合は空白
                vm.items[i].EVAL_USER_NAME = '';
              } else {
                // 上記以外は一次評価者（先月の評価者名を表示）
                vm.items[i].EVAL_USER_NAME = vm.items[i].FIRST_USER_NAME;
              }
            */
            } else {
              // 上記以外は空白
              vm.items[i].EVAL_USER_NAME = '';
            }

            if (evalUserId) {
              for (var j = 0; j < vm.userItems.length; j++) {
                if (vm.userItems[j].USER_ID == evalUserId) {
                  // 評価者の部署名を設定
                  vm.items[i].EVAL_DEPARTMENT_NAME =
                    vm.userItems[j].DEPARTMENT_NAME;
                }
              }
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    async get_evalStatus() {
      // ローディング画像表示
      this.loading = true;

      var emptyItem = { label: '', value: '' };
      this.evalStatusItems.push(emptyItem);

      // 自己評価待ち
      var item1 = {
        label: config.EVAL_STATUS_SELF_WAIT_STR,
        value: config.EVAL_STATUS_SELF_WAIT,
      };
      this.evalStatusItems.push(item1);

      // 自己評価中
      var item2 = {
        label: config.EVAL_STATUS_SELF_DURING_STR,
        value: config.EVAL_STATUS_SELF_DURING,
      };
      this.evalStatusItems.push(item2);

      // 一次評価待ち
      var item3 = {
        label: config.EVAL_STATUS_FIRST_WAIT_STR,
        value: config.EVAL_STATUS_FIRST_WAIT,
      };
      this.evalStatusItems.push(item3);

      // 一次評価中
      var item4 = {
        label: config.EVAL_STATUS_FIRST_DURING_STR,
        value: config.EVAL_STATUS_FIRST_DURING,
      };
      this.evalStatusItems.push(item4);

      // 二次評価待ち
      var item5 = {
        label: config.EVAL_STATUS_SECOND_WAIT_STR,
        value: config.EVAL_STATUS_SECOND_WAIT,
      };
      this.evalStatusItems.push(item5);

      // 二次評価中
      var item6 = {
        label: config.EVAL_STATUS_SECOND_DURING_STR,
        value: config.EVAL_STATUS_SECOND_DURING,
      };
      this.evalStatusItems.push(item6);

      // 完了
      var item7 = {
        label: config.EVAL_STATUS_COMPLETE_STR,
        value: config.EVAL_STATUS_COMPLETE,
      };
      this.evalStatusItems.push(item7);

      // ローディング画像終了
      this.loading = false;
    },
    async getPeriod() {
      this.loading = true;
      let vm = this;
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 年度データ取得
          vm.tmpItems = response.data;
          var nowStr = makeSystemDateStr();
          this.hasPeriod = false;
          this.initPeriodId = '';

          for (var i = 0; i < vm.tmpItems.length; i++) {
            var periodStartDate = makeDateTimeStr(
              'S',
              vm.tmpItems[i].PERIOD_START_DATE
            );
            var periodEndDate = makeDateTimeStr(
              'E',
              vm.tmpItems[i].PERIOD_END_DATE
            );
            // 現在日時が年度開始・終了の期間内かを判定
            if (periodStartDate <= nowStr && periodEndDate >= nowStr) {
              //this.hasPeriod = true;
              this.initPeriodId = vm.tmpItems[i].PERIOD_ID;
            }

            var item = {
              label: vm.tmpItems[i].PERIOD_NAME,
              value: vm.tmpItems[i].PERIOD_ID,
            };
            this.periodItems.push(item);
          }

          // ラベル設定
          for (var j = 0; j < vm.tmpItems.length; j++) {
            if (vm.tmpItems[j].PERIOD_ID == this.initPeriodId) {
              this.period.label = vm.tmpItems[j].PERIOD_NAME;
            }
          }

          this.period.value = this.initPeriodId;

          axios
            .get(
              config.CONNECT_EVALUATIONS_URL +
                '/Evaluations/manages/organization/user/' +
                this.userInfo.SESSION_ID +
                '/' +
                this.userInfo.USER_ID +
                '/' +
                this.userInfo.ORGANIZATION_KEY
            )
            .then((response) => {
              // 組織キーに紐づくユーザー情報取得
              vm.userItems = response.data;
            })
            .catch((error) => {
              let errStr = '';
              if (error.status == 400) {
                errStr = message.MSG_ERROR_SESSION + error;
                this.$refs.dialog.open('error', errStr);
              } else {
                errStr = message.MSG_ERROR_SYTEM + error;
                this.$refs.dialog.open('error', errStr);
              }
            });
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
    async get_department() {
      // 部署情報取得
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          this.departmentItems = [];
          var emptyItem = { label: '', value: '' };
          this.departmentItems.push(emptyItem);
          vm.tmpItems = response.data;
          for (let i = 0; i < vm.tmpItems.length; i++) {
            var item = {
              label: vm.tmpItems[i].DEPARTMENT_NAME,
              value: vm.tmpItems[i].DEPARTMENT_KEY,
            };
            this.departmentItems.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
  },
};
</script>
